module.exports = __webpack_public_path__ + "static/home-yoga-0cbd657d50beba4c90ef5910757061d5.jpg";